import { cva } from 'class-variance-authority';

export const formControlVariant = cva(
  'mb-8 flex flex-col gap-[0.8rem] md:flex-row md:items-baseline',
);

export const formLabelVariant = cva(
  'w-full shrink-0 grow-0 text-sm font-medium md:basis-[29rem] md:text-base ipad-min:basis-[355px]',
);

export const formInputVariant = cva('flex flex-1 flex-col gap-[0.4rem]');
